<template>
  <DropDownFilter
    :menuSections="dropDownMenuSections"
    :setLoadingOverlay="setLoadingOverlay"
    storeModule="SystemUserCollection"
  />
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

import { DropDownSectionConsts } from 'client/util/Constants';
import { SystemUserLabels } from 'client/systemusers/constants/SystemUserConstants';

import DropDownFilter from 'client/components/ItemTable/CollectionFilterComponents/DropDownFilter.vue';
import SystemUserFilters from 'client/components/ItemTable/CollectionFilterComponents/constants/SystemUserFilters';

import DropDownFilterMixin from 'client/components/ItemTable/mixins/DropDownFilterMixin';

const {
  multiSelect,
  selectOne,
} = DropDownSectionConsts;

export default {
  name: 'SystemUserDropDownFilter',

  components: {
    DropDownFilter,
  },

  mixins: [
    DropDownFilterMixin,
  ],

  computed: {
    // mapped getters used in DropDownFilterMixin
    ...mapGetters('SystemUserCollection', [
      'getFilters',
    ]),

    dropDownMenuSections() {
      const menus = [
        {
          menuLabel: 'account status:',
          menuType: multiSelect,
          menuItems: [
            {
              filter: SystemUserFilters.externallyManaged(true),
              label: SystemUserLabels.externallyManaged,
              action: () => {
                this.handleDropDownAction(SystemUserFilters.externallyManaged(true));
              },
            },
            {
              filter: SystemUserFilters.locked(true),
              label: SystemUserLabels.accountLocked,
              action: () => {
                this.handleDropDownAction(SystemUserFilters.locked(true));
              },
            },
            {
              filter: SystemUserFilters.noPassword(false),
              label: SystemUserLabels.noPassword,
              action: () => {
                this.handleDropDownAction(SystemUserFilters.noPassword(true));
              },
            },
            {
              filter: SystemUserFilters.activated(false),
              label: SystemUserLabels.passwordPending,
              action: () => {
                this.handleDropDownAction(SystemUserFilters.activated(false));
              },
            },
            {
              filter: SystemUserFilters.passwordExpired(true),
              label: SystemUserLabels.passwordExpired,
              action: () => {
                this.handleDropDownAction(SystemUserFilters.passwordExpired(true));
              },
            },
            {
              filter: SystemUserFilters.passwordExpiring(14),
              label: SystemUserLabels.passwordExpiring(14),
              action: () => {
                this.handleDropDownAction(SystemUserFilters.passwordExpiring(14));
              },
            },
          ],
        },
        {
          menuLabel: 'permissions:',
          menuType: multiSelect,
          menuItems: [
            {
              filter: SystemUserFilters.sudo(true),
              label: SystemUserLabels.globalAdmin,
              action: () => {
                this.handleDropDownAction(SystemUserFilters.sudo(true));
              },
            },
            {
              filter: SystemUserFilters.sudoPasswordLess(true),
              label: SystemUserLabels.globalAdminPasswordless,
              action: () => {
                this.handleDropDownAction(SystemUserFilters.sudoPasswordLess(true));
              },
            },
            {
              filter: SystemUserFilters.ldap(true),
              label: SystemUserLabels.ldap,
              action: () => {
                this.handleDropDownAction(SystemUserFilters.ldap(true));
              },
            },
            {
              filter: SystemUserFilters.sambaAccess(true),
              label: SystemUserLabels.sambaAccess,
              action: () => {
                this.handleDropDownAction(SystemUserFilters.sambaAccess(true));
              },
            },
          ],
        },
        {
          menuLabel: 'MFA enrollment:',
          menuType: selectOne,
          menuItems: [
            {
              filter: SystemUserFilters.mfaEnrolled(true),
              label: 'enrolled',
              action: () => {
                this.handleDropDownAction(SystemUserFilters.mfaEnrolled(true));
              },
            },
            {
              filter: SystemUserFilters.mfaEnrolled(false),
              label: 'not enrolled',
              action: () => {
                this.handleDropDownAction(SystemUserFilters.mfaEnrolled(false));
              },
            },
          ],
        },
        {
          menuLabel: 'MFA user requirement:',
          menuType: selectOne,
          menuItems: [
            {
              filter: SystemUserFilters.mfaEnabled(true),
              label: 'required',
              action: () => {
                this.handleDropDownAction(SystemUserFilters.mfaEnabled(true));
              },
            },
            {
              filter: SystemUserFilters.mfaEnabled(false),
              label: 'not required',
              action: () => {
                this.handleDropDownAction(SystemUserFilters.mfaEnabled(false));
              },
            },
          ],
        },
      ];

      return menus;
    },
  },

  mounted() {
    this.handleMounted();
  },

  methods: {
    // mapped actions used in DropDownFilterMixin
    ...mapActions('SystemUserCollection', [
      'fetchCollection',
      'setFilter',
      'setFilters',
    ]),
  },
};
</script>
